import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { Modal } from './types';

const modalsSlice = (state: RootState) => state.modals;

export const selectModals = createSelector([modalsSlice], (state): Modal => state);

export const selectModal = <K extends keyof Modal>(key: K) =>
  createSelector([modalsSlice], (state): Modal[K] => state[key]);
